import { Platform } from "react-native";

export const getPlatform = () => {
	const platform = Platform.OS;

	switch (platform) {
		case "ios":
			return "IOS";
		case "android":
			return "ANDROID";
		default:
			return "WEB";
	}
};

export const isWeb = Platform.OS === "web";
export const isAndroid = Platform.OS === "android";
export const isIOS = Platform.OS === "ios";

const getBrowserType = () => {
	if (!isWeb || typeof navigator === "undefined") {
		return "native";
	}

	const userAgent = navigator.userAgent;

	const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
	const isChromiumBased = /Chrome|Chromium|CriOS/i.test(userAgent) && !isSafari;

	if (isSafari) {
		return "safari";
	}
	if (isChromiumBased) {
		return "chromium";
	}
	return "other";
};

export const getBrowserName = () => {
	if (!isWeb || typeof navigator === "undefined") {
		return undefined;
	}

	const { userAgent } = navigator;

	if (/Edg\//i.test(userAgent)) {
		return "Microsoft Edge";
	}
	if (/OPR\/|Opera/i.test(userAgent)) {
		return "Opera";
	}
	if (/Firefox\//i.test(userAgent)) {
		return "Firefox";
	}
	if (/^((?!chrome|android).)*safari/i.test(userAgent)) {
		return "Safari";
	}
	if (/Chrome|Chromium|CriOS/i.test(userAgent)) {
		return "Google Chrome";
	}

	return "Unknown Browser";
};

export const isSafari = getBrowserType() === "safari";
export const isChromium = getBrowserType() === "chromium";
